import React from 'react'
import UiBoundary from '../foundations/UiBoundary'
import styles from './MarketingIsland.module.scss'

const MarketingIsland = ({ children }) => (
  <UiBoundary className={styles.root}>
    {children}
  </UiBoundary>
)

export default MarketingIsland
